export default __webpack_public_path__ + "static/media/ch4_ukghg_map_combustion_20170101T00.1ab6e12d.png";